import React from 'react';

import { Card, CardHeader, CardContent, Divider, CardProps } from '@mui/material';

type Props = {
  title?: string;
  children: JSX.Element | JSX.Element[];
};

const ChildCard = ({ title, children, ...props }: Props & CardProps) => (
  <Card
    sx={{ padding: 0, borderColor: (theme: any) => theme.palette.divider }}
    variant="outlined"
    {...props}
  >
    {title ? (
      <>
        <CardHeader title={title} />
        <Divider />{' '}
      </>
    ) : (
      ''
    )}

    <CardContent>{children}</CardContent>
  </Card>
);

export default ChildCard;
